import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-cf5d9d36"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "home-page" }

import AiExpertiseSection from "@/components/AiExpertiseSection.vue";
import ContactSection from "@/components/ContactSection.vue";
import EvidenceSection from "@/components/EvidenceSection.vue";
import ProfileFocusSection from "@/components/ProfileFocusSection.vue";
import ProfileHero from "@/components/ProfileHero.vue";
import ResponsibilityAreas from "@/components/ResponsibilityAreas.vue";
import VecuraTeaser from "@/components/VecuraTeaser.vue";
import WorkModes from "@/components/WorkModes.vue";

export default /*#__PURE__*/_defineComponent({
  __name: 'HomePage',
  setup(__props) {


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("article", _hoisted_1, [
    _createVNode(ProfileHero),
    _createVNode(ProfileFocusSection),
    _createVNode(ResponsibilityAreas),
    _createVNode(AiExpertiseSection),
    _createVNode(WorkModes),
    _createVNode(VecuraTeaser),
    _createVNode(EvidenceSection),
    _createVNode(ContactSection)
  ]))
}
}

})